// extracted by mini-css-extract-plugin
module.exports = {"InstantBooking":"InstantBooking_InstantBooking__P1ClN","InstantBookingIcon":"InstantBooking_InstantBookingIcon__xyVVQ"};